module.exports = __webpack_public_path__ + "img/line2.992e65c7.jpg";